import { useEffect, useState } from "react";
import { AVISO_VALOR } from "./CatalogoBusca";

export default function FotoComPreco({ theme, blob, legenda = "", onCancelar, onConfirmar }) {
  const th = theme;
  const line = th.nuLine || th.sandDark;
  const [url, setUrl] = useState("");
  const [erro, setErro] = useState("");

  useEffect(() => {
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  const confirmar = () => {
    if (!blob || !url) return;
    const type = blob.type || "image/jpeg";
    const ext = type === "image/png" ? "png" : type === "image/webp" ? "webp" : "jpg";
    const base = String(legenda || "produto").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-|-$/g, "").toLowerCase() || "produto";
    if (onConfirmar(new File([blob], `${base.slice(0, 60)}.${ext}`, { type }), legenda) === false) {
      setErro("Esta imagem excede o limite de envio. Escolha uma foto menor.");
    }
  };

  const campo = { padding: "8px 10px", borderRadius: 4, border: `1px solid ${line}`, fontFamily: "inherit", fontSize: 14, background: "#fff", color: th.text, boxSizing: "border-box" };
  return (
    <div role="dialog" aria-modal="true" aria-label="Preparar foto" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 90, display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}>
      <div style={{ background: "#fff", borderRadius: 6, width: "min(560px, 100%)", maxHeight: "94vh", overflowY: "auto", padding: 14, boxSizing: "border-box", color: th.text }}>
        <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Preparar a foto</div>
        {erro && <div role="alert" style={{ color: "#991B1B", fontSize: 13, marginBottom: 8 }}>{erro}</div>}
        {!url && <div style={{ color: th.muted, fontSize: 14 }}>Abrindo a foto…</div>}
        {url && <img src={url} alt={legenda || "Prévia da foto"} style={{ width: "100%", maxHeight: "65vh", objectFit: "contain", borderRadius: 4, border: `1px solid ${line}` }} />}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 14 }}>
          <button type="button" onClick={onCancelar} style={{ ...campo, cursor: "pointer" }}>Voltar</button>
          <button type="button" onClick={confirmar} disabled={!url} style={{ border: "none", borderRadius: 4, padding: "9px 16px", background: th.accent, color: "#fff", fontWeight: 700, fontSize: 14, cursor: url ? "pointer" : "default", fontFamily: "inherit", opacity: url ? 1 : 0.6 }}>
            Usar esta foto
          </button>
        </div>
        <div style={{ fontSize: 12, color: th.muted, marginTop: 8 }}>{AVISO_VALOR}</div>
        <div style={{ fontSize: 12, color: th.muted, marginTop: 8 }}>A foto vai para a mensagem como prévia. Só é enviada quando você tocar em Enviar.</div>
      </div>
    </div>
  );
}
